import { put, call, takeEvery } from 'redux-saga/effects';
import { getUserProfile } from '../../../requests/user_profile_requests/get_user_profile_request';
import { addUserProfileGroupsList } from '../../../requests/user_profile_groups_requests/add_groups_list';
import { clearUsersCacheRequest } from '../../../../User_create/requests/clear_users_cache';
import { USER_PROFILE_GROUPS_ADD_REQUEST } from '../../constants/user_profile_groups.constants';
import { userProfileGroupsAddSuccess, userProfileGroupsAddFailure } from '../../actions/user_profile_groups_actions/user_profile_groups_add.actions';
import { message_error, message_success } from '../../../../../../components/Message';
import { getErrorMessage } from '../../../../../../shared/helpers';

function* userProfileGroupsAddRequest({ user_id, add_groups }) {
    try {
        const { result, msg, error } = yield call(addUserProfileGroupsList, user_id, add_groups);
        if (result) {
            const profile = yield call(getUserProfile, user_id);
            yield put(userProfileGroupsAddSuccess(profile.options.groups));
            message_success('User Group Added Successfully!');

            yield call(clearUsersCacheRequest);
        } else {
            yield put(userProfileGroupsAddFailure(error));
            message_error(msg);
        }
    } catch (error) {
        message_error(getErrorMessage(error));
    }
}

export default function* userProfileGroupsAddSaga() {
    yield takeEvery(USER_PROFILE_GROUPS_ADD_REQUEST, userProfileGroupsAddRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_profile_groups_sagas/user_profile_groups_add.saga.js